<template>
    <nav :class="{
            'pagination-vatgia': true,
            'pagination-vatgia-mobile': $detect == 'mobile'
        }">
        <ul class="pagination justify-content-end" v-if="last_page <= 5">
            <li :class="{
                    'page-item': true,
                    'active': item === current_page
                }"
                @click="item !== current_page ? callDataFunction(item) : ''"
                v-for="(item, index) in last_page" :key="index">
                <div class="page-link">{{item}}</div>
            </li>
        </ul>
        <ul class="pagination justify-content-end" v-else>
            <li class="page-item" v-if="$detect == 'mobile'">
                <div class="page-link prev-page text-body" aria-label="Previous">
                    Trang {{current_page}}
                </div>
            </li>
            <li class="page-item" @click="callDataFunction(1)"
                v-if="current_page > 2 && windowWidth > 320">
                <div class="page-link prev-page" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </div>
            </li>
            <li class="page-item" v-if="current_page > 1">
                <div class="page-link" @click="callDataFunction(current_page - 1)">
                    Previous
                </div>
            </li>
            <li :class="{
                    'page-item': true,
                    'active': item === current_page
                }"
                @click="item !== current_page ? callDataFunction(item) : ''"
                v-for="(item, index) in i" :key="index">
                <div class="page-link">{{item}}</div>
            </li>
            <li class="page-item" v-if="pushLastPage">
                <div class="page-link page-between">...</div>
            </li>
            <li class="page-item" v-if="pushLastPage"
                @click="callDataFunction(last_page)">
                <div class="page-link">{{last_page}}</div>
            </li>
            <li class="page-item" v-if="current_page != last_page"
                @click="callDataFunction(current_page + 1)">
                <div class="page-link">Next</div>
            </li>
            <li class="page-item">
                <div class="page-link p-1 go-page">
                    <input type="text" :placeholder="windowWidth <= 320 ? 'Trang' : 'Tới trang'"
                        class="border-0"
                        @focus="(e) => e.target.select()"
                        v-model="goPage"
                        @change="callGoLink()"
                        :style="'width: ' + ($detect == 'web' || ($detect == 'mobile' && windowWidth > 320) ? 70 : 40) + 'px'"/>
                    <span class="ml-1">/ {{last_page}}</span>
                </div>
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    props: {
        current_page: {
            type: Number,
            default: 0,
        },
        next_page: {
            type: Number,
            default: 0,
        },
        last_page: {
            type: Number,
            default: 0,
        },
        scroll_top: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            callData: '',
            goPage: '',
            windowWidth: window.screen.width,
            i: [],
            pushLastPage: true,
        }
    },
    watch: {
        current_page(val){
            let i = 0, last_i = 0;
            this.pushLastPage = true;
            this.i = [];
            if(this.current_page <= 4){
                i = 1;
                last_i = 5;
            }else if(this.last_page - this.current_page <= 4){
                i = this.last_page - 5;
                last_i = this.last_page;
                this.pushLastPage = false;
            }else{
                i = this.current_page - 2;
                last_i = this.current_page + 2;
            }
            if(this.$detect == 'mobile') this.pushLastPage = false;
            if(this.$detect == 'web'){
                for(let i1 = i; i1 <= last_i; i1++){
                    this.i.push(i1);
                }
            }
        }
    },
    created() {
        let attrs = this.$attrs;
        if(typeof(attrs.callData) != 'function'){
            console.error('attr callData is a function');
        }else{
            this.callData = attrs.callData;
        }
    },
    methods: {
        async callDataFunction(page){
            await this.callData(page);
            if(this.scroll_top){
                window.scrollTo(0, 0)
            }
        },
        callGoLink(){
            if(isNaN(this.goPage) || this.goPage % 1 != 0){
                this.goPage = '';
            }else{
                if(this.goPage < 1){
                    this.goPage = 1;
                }else if(this.goPage > this.last_page){
                    this.goPage = this.last_page
                }
                this.callDataFunction(this.goPage)
            }
        }
    },
}
</script>